<div class="product-wrapper">
  <div [style]="getBackgroundColor().borderStyle" class="card-product" [ngClass]="user.role">
    <div class="justify-content-center mobileAdjustsH"
      style="flex-grow: 1; align-items: center; align-self: center; place-content: center;">
      <div class="d-flex card-image-container" *ngIf="product.bonus !== null" [ngClass]="{
          'placeholder-img': showProductImage().endsWith(
            'product_placeholder.png'
          )
        }">
        <img [src]="showProductImage()" alt="Product image" class="cursor-pointer product-img"
          (click)="openProductDetails()" [ngClass]="{
            'placeholder-img-bio2': showProductImage().endsWith(
              'product_placeholder.png'
            )
          }" />
        <div *ngIf="showProductImage().endsWith('product_placeholder.png')" class="conditional-placeholder">
          <span>Imagem não disponibilizada</span>
        </div>
      </div>
      <div class="justify-content-start align-items-end">
        <!-- Labels Container -->
        <div class="labels-container">
          <!-- Type G / V logic -->
          <!-- Bonus logic -->
          <div class="over-image-discont" *ngIf="product.bonus.length > 0 || hasActiveQuantityCampaign"
            (click)="openProductBonus()"
            [ngClass]="{'conditionalBonus': getBackgroundColor().label!.length > 0 || product.request}">
            <img src="../../../assets/Icons/BonusProduto.png" alt="icon">
            Produto em campanha
          </div>
            <!-- Produto por encomenda/requisição -->
           <div class="over-image-discont request-extra-label"
            *ngIf="product.request && product.request != '' && isIvcOrVetfamilyProduct()"
            [style]="getRequestBackgroundColor().backgroundColor" [ngClass]="{
                'with-bonus': product.bonus.length > 0 || hasActiveQuantityCampaign
              }">
            <img [src]="getRequestBackgroundColor().icon" alt="icon">

            <span>
              {{ getRequestBackgroundColor().label }}
            </span>
          </div>
          <!-- IVC / Vetfamily -->
          <div class="over-image-discont agreement-extra-label"
            *ngIf="getBackgroundColor().label || getBackgroundColor().iconOnly"
            [style]="getBackgroundColor().backgroundColor" [ngClass]="{
                'with-bonus': product.bonus.length > 0 || hasActiveQuantityCampaign,
                'with-request': product.request && product.request != '' && isIvcOrVetfamilyProduct()}">
            <img [src]="getBackgroundColor().icon" alt="icon">

            <span *ngIf="getBackgroundColor().label">
              {{ getBackgroundColor().label }}
            </span>
          </div>
        </div>

        <!-- Disabling favorites functionality for lab user -->
        <ng-container *ngIf="user.role !=='Laboratorio'">
          <button mat-fab class="over-image-favorite" *ngIf="!product.favorite && !isAdmin && !inFavorite"
            (click)="handleFavoriteClick()">
            <mat-icon>favorite_border</mat-icon>
          </button>
          <button mat-fab class="over-image-favorite" *ngIf="product.favorite && !isAdmin && !inFavorite"
            (click)="handleFavoriteClick()">
            <mat-icon>favorite</mat-icon>
          </button>
          <button mat-fab class="over-image-favorite" *ngIf="product.favorite && !isAdmin && inFavorite"
            (click)="handleRemoveFavoriteClick()">
            <mat-icon>delete</mat-icon>
          </button>
        </ng-container>
      </div>
    </div>
    <div class="bottom-part">
      <!-- !! Nome -->
      <div class="p-0 mt-4 d-flex flex-column justify-content-center mobileAdjustM">
        <div class="d-flex flex-row" style="justify-content: space-between;">
          <span class="text-left product-label"
            [ngStyle]="{'color': product.situacao == 'Validade' ? '#F97066' : 'inherit'}"
            style="display: -webkit-box; -webkit-line-clamp: 3; line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;"
            matTooltip="{{ product.decription }}" [matTooltipPosition]="'above'" [matTooltipShowDelay]="'500'"
            [matTooltipHideDelay]="'100'">
            {{ product.decription }}
          </span>
          <img *ngIf="product.situacao == 'Validade'" src="../../../assets/Icons/situacao.png" alt="situacao"
            matTooltip="Artigo com validade curta" [matTooltipPosition]="'above'"
            style="align-self: center; cursor: pointer;">
        </div>

        <!-- !! Descontos e Stock -->
        <div>
          <!-- Above line (only shown if 2 or more discounts) -->
          <div *ngIf="getDiscountCount(product) >= 2" class="d-flex justify-content-between align-items-center mb-1">

            <!-- IVA (only when 3 discounts) -->
            <div *ngIf="getDiscountCount(product) >= 3" [style]="getIva().backgroundColor" class="dinamicIva">
              <span [style]="getIva().color">IVA {{ getIva().label }}%</span>
            </div>

            <!-- STOCK info (left aligned for 2 discounts, right aligned for 3 discounts) -->
            <div *ngIf="getDiscountCount(product) === 2" class="custom-button" [ngClass]="{
                   green: product.stock >= 10,
                   yellow: product.stock < 10 && product.stock > 0,
                   red: product.stock === 0
                 }">
              {{
              product.stock > 0
              ? product.stock >= 10
              ? "Stock disponível"
              : "Stock limitado"
              : "Sem stock"
              }}
            </div>

            <div *ngIf="getDiscountCount(product) >= 3" class="custom-button ms-auto" [ngClass]="{
                   green: product.stock >= 10,
                   yellow: product.stock < 10 && product.stock > 0,
                   red: product.stock === 0
                 }">
              {{
              product.stock > 0
              ? product.stock >= 10
              ? "Stock disponível"
              : "Stock limitado"
              : "Sem stock"
              }}
            </div>
          </div>

          <!-- INSIDE block -->
          <div class="discounts-stock" [class.ocult]="product.request === 'E'">
            <div class="d-flex flex-row" style="align-items: center;">

              <!-- LAB Discount -->
              <ng-container *ngIf="product.labDiscount && product.labDiscount > 0 && !hasFlashDiscount">
                <span class="slashedPrice" *ngIf="product.oldPrice">
                  {{ product.oldPrice | number: '1.2-2' }}€
                </span>
                <span class="discountPercentageSection">
                  {{ product.labDiscount }}%
                </span>
              </ng-container>

              <!-- Campaign Discount -->
              <ng-container *ngIf="applicableCampaignDiscountPercentage !== null">
                <span class="slashedPrice">
                  {{ getLabPrice(product) | number: '1.2-2' }}€
                </span>
                <span class="discountPercentageSection">
                  {{ applicableCampaignDiscountPercentage }}%
                </span>
              </ng-container>

              <!-- Bio2 Discount -->
              <ng-container *ngIf="product.discountPercentage && product.discountPercentage > 0">
                <span class="slashedPrice">
                  {{ getLabQuantityPrice(product, applicableCampaignDiscountPercentage ?? 0) | number: '1.2-2' }}€
                </span>
                <span class="discountPercentageSection">
                  {{ product.discountPercentage }}%
                </span>
              </ng-container>

              <!-- Other Discount -->
              <ng-container *ngIf="product.otherDiscount && product.otherDiscount > 0">
                <span class="slashedPrice">
                  {{ getLabQuantityBio2Price(product, applicableCampaignDiscountPercentage ?? 0) | number: '1.2-2' }}€
                </span>
                <span class="discountPercentageSection">
                  {{ product.otherDiscount }}%
                </span>
              </ng-container>

              <!-- IVA (only shown inside if 0, 1, or 2 discounts) -->
              <div *ngIf="getDiscountCount(product) < 3" [style]="getIva().backgroundColor" class="dinamicIva ms-auto">
                <span [style]="getIva().color">
                  IVA {{ getIva().label }}%
                </span>
              </div>
            </div>

            <!-- Stock info (only shown inside if < 2 discounts OR no quantity campaign) -->
            <div *ngIf="getDiscountCount(product) < 2 && !hasApplicableQuantityCampaign" class="custom-button"
              [ngClass]="{
                   green: product.stock >= 10,
                   yellow: product.stock < 10 && product.stock > 0,
                   red: product.stock === 0
                 }">
              {{
              product.stock > 0
              ? product.stock >= 10
              ? "Stock disponível"
              : "Stock limitado"
              : "Sem stock"
              }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div [class.adjusts-request]="product.request === 'E'">
          <div [class.request]="product.request === 'E'" style="display: none">
            Preço sob consulta
          </div>
          <!-- !! Mais menos -->
          <div class="d-flex flex-row plus-less" [class.ocult]="product.request !== 'E'"
            [ngClass]="{ disabled: isProcessing }">
            <div [ngClass]="{ disabled: isProcessing || product.productQuantity == 0 }" class="less-btn">
              <img [ngClass]="{ disabled: isProcessing }" src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                (click)="isProcessing ? null : removeQuantityClick(product)" />
            </div>
            <input [ngClass]="{ disabled: isProcessing }" class="number-input" [ngModel]="product.productQuantity"
              type="number" max="1000" (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(inputEncomenda)"
              (blur)="changeQuantity(inputEncomenda.value, product, product.productQuantity)" #inputEncomenda />
            <div [ngClass]="{ disabled: isProcessing }" class="plus-btn">
              <img [ngClass]="{ disabled: isProcessing }" src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                (click)="addQuantityClick(product)" />
            </div>
            <div [@moveToTopRight]="animationState" class="ball-container">
              <div class="ball">
                <img [src]="showProductImage()">
              </div>
            </div>
          </div>
        </div>
        <!-- !! BTNS -->
        <div class="d-flex toogle-btns mobileToogle2" [class.ocult]="product.request === 'E'"
          [class.adjust-mobile-dimentions]="product.request">
          <div class="d-flex flex-row mobileToogle1">
            <button *ngIf="authService.hasPermissions(['27'])" [disabled]="buttonDisable" (click)="toggleButton()"
              [ngClass]="{
                'btn-euro-active d-flex': isCartButtonActive,
                'd-flex btn-euro-disable': !isCartButtonActive,
                'userPetVet': !authService.hasPermissions(['27'])
              }">
              <mat-icon *ngIf="isCartButtonActive; else cartGreenDisable" svgIcon="cart" class="h-auto"></mat-icon>
              <ng-template #cartGreenDisable>
                <mat-icon svgIcon="cart-green" class="svg-icon-points"></mat-icon>
              </ng-template>
              <!-- Final Price -->
              <span class="price-span">
                {{
                (getDiscountCount(product) > 0
                ? getFinalChainedPrice(product, applicableCampaignDiscountPercentage ?? 0)
                : product.oldPrice)
                | number : '1.2-2' }}€
              </span>
            </button>
            <button *ngIf="!authService.hasPermissions(['27'])" [disabled]="buttonDisable"
              class="userPetVet btn-euro-active d-flex">
              <mat-icon *ngIf="isCartButtonActive; else cartGreenDisable2" svgIcon="cart" class="h-auto"></mat-icon>
              <ng-template #cartGreenDisable2>
                <mat-icon svgIcon="cart-green" class="svg-icon-points"></mat-icon>
              </ng-template>
              <ng-container *ngIf="getDiscountCount(product) > 0; else noDiscount">
                <span class="price-span">
                  {{ (getFinalChainedPrice(product, applicableCampaignDiscountPercentage ?? 0)) | number: '1.2-2' }}€
                </span>
              </ng-container>
              <ng-template #noDiscount>
                <span class="price-span">{{ product.oldPrice | number : '1.2-2' }}€</span>
              </ng-template>
            </button>

            <button *ngIf="authService.hasPermissions(['27'])" [disabled]="buttonDisable || this.isReadingPoints"
              matTooltip="A carregar pontos..." [matTooltipDisabled]="!isReadingPoints" (click)="toggleButton()"
              [ngClass]="{
                'btn-points-disable d-flex': isCartButtonActive,
                'btn-points-active d-flex ': !isCartButtonActive
              }">
              <mat-icon *ngIf="isCartButtonActive; else ticketWhiteIcon" svgIcon="ticket" class="svg-icon-points">
              </mat-icon>
              <ng-template #ticketWhiteIcon>
                <mat-icon svgIcon="ticket-white" class="svg-icon-points"></mat-icon>
              </ng-template>
              <span>{{ product.points }}</span>
            </button>
          </div>
          <!-- !! Mais menos -->
          <div class="d-flex flex-row plus-less" [ngClass]="{ disabled: isProcessing }">
            <div [ngClass]="{ disabled: isProcessing || product.productQuantity == 0 }" class="less-btn">
              <img [ngClass]="{ disabled: isProcessing }" src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                (click)="isProcessing ? null : removeQuantityClick(product)" />
            </div>
            <input [ngClass]="{ disabled: isProcessing }" class="number-input" [ngModel]="product.productQuantity"
              type="number" max="1000" (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(input)"
              (blur)="changeQuantity(input.value, product, product.productQuantity)" #input />
            <div [ngClass]="{ disabled: isProcessing }" class="plus-btn">
              <img [ngClass]="{ disabled: isProcessing }" src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                (click)="addQuantityClick(product)" />
            </div>
            <div [@moveToTopRight]="animationState" class="ball-container">
              <div class="ball">
                <img [src]="showProductImage()">
              </div>
            </div>
          </div>
        </div>

        <!-- Labs flash campaigns -->
        <div class="labsCampaigns mobileToogle" *ngIf="user.role =='Laboratorio'">
          <!-- Desconto manual -->
          <div class="d-flex flex-row plus-less ">
            <span style="margin-right: 5px;">Desconto manual: </span>
            <div class="less-btn">
              <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                (click)="removeDiscountQuantityClick(product)" />
            </div>
            <input class="number-input" [ngModel]="product.labFlashDiscount" type="number" step="0.01" max="1000"
              (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(discountQuantityInput)"
              (blur)="changeDiscountQuantity(discountQuantityInput.value, product, product.labFlashDiscount)"
              #discountQuantityInput />
            <span class="percent">%</span>
            <div class="plus-btn">
              <img src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                (click)="addDiscountQuantityClick(product)" />
            </div>
          </div>

          <!-- Bonus manual -->
          <div class="d-flex flex-row plus-less">
            <span style="margin-right: 5px;">Bónus manual: </span>
            <div class="less-btn">
              <img src="../../../assets/Icons/less-icon.png" alt="lessIcon"
                (click)="removeBonusQuantityClick(product)" />
            </div>
            <input class="number-input" [ngModel]="product.labFlashBonus" type="number" max="1000"
              (keydown)="onKeyDown($event)" (keyup.enter)="onEnterPress(bonusQuantityInput)"
              (blur)="changeBonusQuantity(bonusQuantityInput.value, product, product.labFlashBonus)"
              #bonusQuantityInput />
            <div class="plus-btn">
              <img src="../../../assets/Icons/plus-icon.png" alt="PlusIcon"
                (click)="addBonusDiscountQuantityClick(product)" />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div *ngIf="showCampaignProductDiv">
    <app-dialog-product-campaign [productData]="product" style="top: 50px;
    left: 54px; position: absolute;"></app-dialog-product-campaign>
  </div>
</div>